/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// TODO: Fix the type of `item` ... probably should be `SearchResultItem` but there are object keys referenced that are not in the type
export function getTargetUri(
    item: any,
    cmsDomain = process.env.SITE_ROOT,
    kbDomain = process.env.SN_KB_EXT_URL
): string {
    if (item.entity_type === 'campground' && item.reservable) {
        return `/camping/campgrounds/${item.entity_id}`;
    }
    if (item.campsite_id) {
        return `/camping/campsites/${item.campsite_id}`;
    }
    if (item.entity_type === 'permit') {
        return `/permits/${item.entity_id}`;
    }
    if (item.entity_type === 'vehiclepermit') {
        return `/vehiclepermits/${item.entity_id}`;
    }
    if (item.entity_type === 'tour') {
        const parentId = item.parent_entity_id ? item.parent_entity_id : item.parent_id;
        return `/ticket/${parentId}/ticket/${item.entity_id}`;
    }
    if (item.entity_type === 'ticketfacility') {
        return `/ticket/facility/${item.entity_id}`;
    }
    if (item.entity_type === 'timedentry_tour') {
        const parentId = item.parent_entity_id ? item.parent_entity_id : item.parent_id;
        return `/timed-entry/${parentId}/ticket/${item.entity_id}`;
    }
    if (item.entity_type === 'timedentry') {
        return `/timed-entry/${item.entity_id}`;
    }
    if (item.entity_type === 'recarea') {
        return `/gateways/${item.entity_id}`;
    }
    if (item.entity_type === 'pass') {
        return `/sitepass/${
            item.park_pass_facility_id ? item.park_pass_facility_id : item.entity_id
        }`;
    }
    if (item.entity_type === 'activitypass') {
        return `/activitypass/${item.entity_id}`;
    }
    if (item.entity_type === 'treepermit') {
        return `/tree-permits/${item.entity_id}`;
    }
    if (item.entity_type === 'venuereservations') {
        return `/venues/${item.entity_id}`;
    }
    if (item.entity_type === 'venuereservations_venue') {
        const parentId = item.parent_entity_id ? item.parent_entity_id : item.parent_id;
        return `/venues/${parentId}/details/${item.entity_id}`;
    }
    if (item.entity_type === 'program') {
        return `/programs/${item.entity_id}`;
    }
    if (item.entity_type === 'kb') {
        // ServiceNow knowledge base
        return `${kbDomain}?id=kb_article&sys_id=${item.entity_id}`;
    }
    if (item.entity_type === 'cms') {
        // navigate to CMS article - the Drupal way
        const name = item.name.toLowerCase().split(' ').join('-');
        const type = item.content_type.toLowerCase().split('_').join('-');
        return `${cmsDomain}/articles/${type}/${name}/${item.entity_id}`;
    }
    if (
        item.entity_type === 'page' ||
        item.entity_type === 'giftcard' ||
        item.entity_type === 'interagencypass'
    ) {
        // page
        return item.url as string; // Casting because for now the type of item is `any`
    }

    return `/camping/poi/${item.entity_id}`;
}
